
    import '/opt/buildhome/repo/docs/playground/copilot.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-playground-copilot-demo-copilot"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/docs/playground/copilot.en-US.md?type=demo')
};